// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"36e1b7fb","212":"0bc0300d","221":"43c7860d","225":"1142e9ca","372":"86dadf44","490":"d7f7b1f8","523":"2802ebdb","593":"6771450d","638":"c8369b9d","642":"3776ccc9","810":"f1a524ca"}[chunkId] + ".chunk.css";
};